var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2504 9.75293C6.2504 9.95184 6.32941 10.1426 6.47007 10.2833C6.61072 10.4239 6.80149 10.5029 7.0004 10.5029C7.19931 10.5029 7.39007 10.4239 7.53073 10.2833C7.67138 10.1426 7.7504 9.95184 7.7504 9.75293C7.7504 9.55402 7.67138 9.36325 7.53073 9.2226C7.39007 9.08195 7.19931 9.00293 7.0004 9.00293C6.80149 9.00293 6.61072 9.08195 6.47007 9.2226C6.32941 9.36325 6.2504 9.55402 6.2504 9.75293ZM6.5004 5.00293V7.87793C6.5004 7.94668 6.55665 8.00293 6.6254 8.00293H7.3754C7.44415 8.00293 7.5004 7.94668 7.5004 7.87793V5.00293C7.5004 4.93418 7.44415 4.87793 7.3754 4.87793H6.6254C6.55665 4.87793 6.5004 4.93418 6.5004 5.00293ZM13.9332 11.8779L7.43321 0.62793C7.33634 0.460742 7.16915 0.37793 7.0004 0.37793C6.83165 0.37793 6.6629 0.460742 6.56758 0.62793L0.0675835 11.8779C-0.124604 12.2123 0.116021 12.6279 0.500396 12.6279H13.5004C13.8848 12.6279 14.1254 12.2123 13.9332 11.8779ZM1.69102 11.442L7.0004 2.25137L12.3098 11.442H1.69102Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.25ff0cd2dbd3044736d25d7f3bc489cc.svg";
export { ForwardRef as ReactComponent };